import axios from "axios";
import {RouterHelper} from "@morningtrain/react-navigation";

export default class Request {

    static parseResponse = (response) => {

        if(response.data){
            return response.data;
        }

        return response;

    }

    static make(route, queryParams = {}, data = {}) {

        const router = new RouterHelper();

        const method = router.method(route);

        if(method === 'get' || method === 'GET') {
            queryParams = {...queryParams, ...data};
            data = null;
        }

        let options = {
            method: method,
            url: router.route(route, queryParams, queryParams),
            data: data
        };

        return axios.request(options).then(Request.parseResponse);
    }

}
